module.exports = __webpack_public_path__ + "img/arrow-playlist-optionsOne.6c785c35.svg";